import { useEffect, useState } from "react";
import { normalizeAllForList } from "@core/utils/listQuery";
import { fetchFinanceDeductiblesAsync } from "@features/admin/finance/deductible/services/financeDeductibleSvc";
import {
    FinanceDeductible,
    FinanceDeductibleQueryParams,
    FinanceDeductibleResponse,
} from "@features/admin/finance/deductible/types/financeDeductible";

export function useFinanceDeductible(
    params: FinanceDeductibleQueryParams,
    options: { enabled?: boolean } = { enabled: true }
) {
    const [data, setData] = useState<FinanceDeductible[]>([]);
    const [current_page, setCurrentPage] = useState(params.page || 1);
    const [from, setFrom] = useState<number | undefined>(undefined);
    const [last_page, setLastPage] = useState<number | undefined>(undefined);
    const [per_page, setPerPage] = useState<number | undefined>(undefined);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    const reload = async () => {
        if (!options?.enabled) return;
        setLoading(true);
        try {
            const { nationId, ...rawFetchParams } = params;
            const fetchParams = normalizeAllForList(rawFetchParams, ["freetext", "isActive"]);
            const response = await fetchFinanceDeductiblesAsync(nationId, fetchParams);
            const payload = response?.getData();
            if (Array.isArray(payload)) {
                setData(payload);
                setCurrentPage(1);
                setFrom(payload.length ? 1 : undefined);
                setLastPage(1);
                setPerPage(payload.length);
                setTotal(payload.length);
            } else if (payload) {
                const page = payload as FinanceDeductibleResponse;
                setData(page.data || []);
                setCurrentPage(page.current_page || 1);
                setFrom(page.from);
                setLastPage(page.last_page);
                setPerPage(page.per_page);
                setTotal(page.total || 0);
            }
        } finally {
            setLoading(false);
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { reload(); }, [
        params.nationId, params.page, params.all,
        params.freetext, params.isActive,
        options.enabled,
    ]);

    return { data, current_page, from, last_page, per_page, total, loading, reload };
}
